import { useEffect } from "react";
import {
  getContentMode,
  normalizeContentKind,
  flushContentImpressions,
  queueContentImpression,
} from "../../services/mediaAnalyticsService";

export function useContentImpression(ref, item, options) {
  useEffect(function () {
    var element = ref && ref.current;
    if (!element || !item || !item.slug || typeof IntersectionObserver === "undefined") return;

    var hasSent = false;
    var observer = new IntersectionObserver(function (entries) {
      var entry = entries && entries[0];
      if (!entry || hasSent || !entry.isIntersecting || entry.intersectionRatio < 0.5) return;

      hasSent = true;
      queueContentImpression({
        contentKey: item.slug,
        mode: getContentMode(item),
        contentKind: normalizeContentKind(item),
        surface: options?.surface || "webtv",
        source: options?.source || "content_row",
        containerKey: options?.containerKey || "",
        position: options?.position || 0,
      });
      observer.disconnect();
    }, { threshold: [0.5] });

    observer.observe(element);

    return function () {
      observer.disconnect();
      flushContentImpressions({ keepalive: true });
    };
  }, [
    ref,
    item,
    item?.slug,
    item?.kind,
    item?.contentType?.kind,
    item?.isLive,
    options?.surface,
    options?.source,
    options?.containerKey,
    options?.position,
  ]);
}
